<template>
  <AppDetailSkeleton v-if="loading" />

  <div v-else>
    <FormModal v-if="showPopup" :closePopup="closePopup" />
    <Navbar @click="handleNavbarLinkClick" :openPopup="openPopup" />
    <MainBanner v-if="bannerData" :data="bannerData" :openPopup="openPopup" />
    <!-- <About v-if="aboutData" :data="aboutData" /> -->
    <IncludedBestFeatures v-if="keyFeaturesData" :data="keyFeaturesData" />
    

      <AppScreens v-if="appData?.app_screens" :app_screens="appData?.app_screens" :pb="roleWiseFeaturesData?.length ? 'pb-50':'pb-75'"/>
    
    

      <RoleWiseFeatures v-if="roleWiseFeaturesData" :role_wise_features="roleWiseFeaturesData" :pt="appData?.app_screens?.length ? 'pt-50':'pt-75'" />
 
    <ScheduleDemo v-if="scheduleDemoData" :schedule_demo="scheduleDemoData" />
    <Screenshots v-if="appData?.dashboard_screenshots?.length > 0"
      :dashboard_screenshots="appData?.dashboard_screenshots" />
    <AppAddOnsSection v-if="appAddOnsData" :app_add_ons="appAddOnsData" />
    <!-- Tech Notes -->



    <div class="outer-container"  v-if="appData?.tech_notes">
      <div class="container">
        <span>Technical Insights</span>
        <div v-html="tech_notes">
        </div>
      </div>
      <img src="../../assets/images/Technical-animation.png" alt="animation-image" class="animation-image-one">
      <img src="../../assets/images/Technical-animation02.png" alt="animation-image" class="animation-two-image">


    </div>
    <!-- <BestFeaturesEver v-if="appData?.what_we_offer" :what_we_offer="appData?.what_we_offer" /> -->
    <!-- <Video v-if="appData?.embed_video?.length > 0" :embed_video="appData?.embed_video" /> -->
    <IntroVideoSection :embed_video="embed_video" :appName="appData?.name"
      :heading="`Watch Our Most Watched ${appData?.name || 'App'} Video`" :description="videoDescription"
      ctaText="Get Started" ctaLink="/contact" />
    <BestAppStaticSection :appName="appData?.name || 'App'" />
    <Pricing v-if="pricingPlanData" :pricingPlan="pricingPlanData" />
    <HowItWorksSteps />
    <Team v-if="appData?.our_expertises?.length > 0" :our_expertises="appData?.our_expertises" />
      <div class="raedy-to-launch">
    <div v-if="appData?.promo_notes && promo_notes" class="container mt-5 mb-5" v-html="promo_notes"></div>
          <img src="../../assets/images/Technical-animation.png" alt="animation-image" class="animation-image-one">
      <img src="../../assets/images/Technical-animation02.png" alt="animation-image" class="animation-two-image">

    </div>
      
      <div class="container">
      <BlogFaq v-if="faq?.length" :faq_Data="faq" />
    </div>
    
    <AppDownloadOne v-if="whyUsData" :why_us="whyUsData" />
    <Partner v-if="appData" />
    <LatestApps v-if="relatedAppsToShow?.length > 0" :apps="relatedAppsToShow" />
    <AppReviews v-if="appData" />
   

    <!-- Promo Notes -->
    <LatestBlogs v-if="relatedBlogsToShow?.length > 0" :blogs="relatedBlogsToShow" />

    <iframe v-if="appData" frameborder="0" class="iframe-form"
      src="https://forms.zohopublic.in/meandersoftwarecontact/form/ClientNeedsAssessmentForm/formperma/4fjH7ZBQUI7rdg6ZqA85n4ldQD4ajNkC_-RXMdrXXPs">
    </iframe>
    <FooterStyleFour v-if="appData" />
  </div>
</template>

<style>
.outer-container span {
  color: #ED2775;
  display: block;
  padding-bottom: 10px;
  text-transform: uppercase;
}

.outer-container {
  width: 960px;
  margin: 50px auto;
  padding: 50px;
  position: relative;
  background: linear-gradient(279.99deg, #9F5FF196 -1.19%, #FF54B042 50.99%, #FF9F5A69 100%);
  border-radius: 100px 20px 100px 20px;
}

img.animation-two-image {
  position: absolute;
  bottom: 50px;
  right: -100px;
  animation: movebounce 2s linear infinite;
}

img.animation-image-one {
  position: absolute;
  top: 40px;
  left: -90px;
  animation: movebounce 2s linear infinite;
}

@media screen and (max-width: 767px) {
  .outer-container {
    width: auto;
    margin: 40px 20px !important;
    padding: 20px 0px;
    border-radius: 10px;
  }

  .overview-content p {
    text-align: center;
  }

  .outer-container .container.mt-5.mb-5 {
    margin-top: 0rem !important;
    padding: 0 20px;
  }


 
}
</style>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useGetAppBySlug } from "../../services/graphqlService";
import axios from "axios";
import MarkdownIt from 'markdown-it';
import markdownItAnchor from 'markdown-it-anchor';
import { updateMetaTags, defaultMetaData, generateAltText } from "../../utils/seoUtils";
import { injectSchemaMarkup, generateAppDetailSchema } from "../../utils/schemaUtils";

// Components
import Navbar from "../Layout/Navbar.vue";
import MainBanner from "../HomeThree/MainBanner.vue";
import About from "../AboutApp/AboutApp.vue";
import IncludedBestFeatures from "../usedComponents/IncludedBestFeatures.vue";
import Team from "../TeamOne/TechnologiesTeam.vue";
import BestFeaturesEver from "../FeaturesOne/AppBestFeatureEver.vue";
import AppScreens from "../HomeThree/AppScreens.vue";
import Screenshots from "../HomeTwo/Screenshots.vue";
import RoleWiseFeatures from "../Screenshots/RoleWiseFeatures.vue";
import Video from "../HomeOne/Video.vue";
import Pricing from "../HomeOne/Pricing.vue";
import AppDownloadOne from "../AppDownload/AppDownloadOne.vue";
import Partner from "../Common/Partner.vue";
import ScheduleDemo from "../Common/AppDownload.vue";
import FooterStyleFour from "../Layout/FooterStyleFour.vue";
import AppReviews from "./AppReviews.vue";
import FormModal from "../HomeThree/FormModal.vue";
import ogImg from '../../assets/images/black-logo.png'
import AppAddOnsSection from "../FeaturesOne/AppAddOnsSection.vue";
import BestAppStaticSection from "../HomeThree/BestAppStaticSection.vue";
import IntroVideoSection from "../HomeOne/IntroVideoSection.vue";
import LatestApps from "../TemplatesAndThemes/LatestApps.vue";
import LatestBlogs from "../BlogOne/LatestBlogs.vue";
import BlogFaq from "../ResourceDetail/Blog_faq.vue";
import AppDetailSkeleton from "../Loader/AppDetailSkeleton.vue";
import HowItWorksSteps from "../Common/HowItWorksSteps.vue";

// Create markdown instance
const md = new MarkdownIt().use(markdownItAnchor);

// Route
const route = useRoute();
const showPopup = ref(false);
// Apollo Composable - Track Slug as reactive
const slug = ref(route.params.slug);
const { result, loading, onError } = useGetAppBySlug(slug);
 

// React to route param change
watch(
  () => route.params.slug,
  (newSlug) => {
    slug.value = newSlug;
  }
);

// Popup control
const openPopup = () => (showPopup.value = true);
const closePopup = () => (showPopup.value = false);
 

// Computed from Apollo result
const appData = computed(() => result.value?.apps?.[0] || null);
const bannerData = computed(() => {
  if (!appData.value) return null;
  return {
    name: appData.value.name,
    title: appData.value.title,
    description: appData.value.description,
    screenshot_1: appData.value.screenshot_1,
    screenshot_2: appData.value.screenshot_2,
  };
});



// Comprehensive SEO meta tags with direct DOM manipulation
const setAppMetaTags = () => {
  if (!appData.value) return;

  // Helper to set or update a meta tag
  function setMeta(name, content, attr = 'name') {
    let element = document.querySelector(`meta[${attr}="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attr, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content || '');
  }

  // Helper to safely truncate text
  function safeTruncate(text, maxLength) {
    if (!text || typeof text !== 'string') return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

  // Helper to get image URL with fallbacks
  function getImageUrl() {
    // First priority: Use specific OG image from backend
    if (appData.value?.og_tags?.og_image?.url) {
      return `https://content.meander.software${appData.value.og_tags.og_image.url}`;
    }
    // Second priority: Use specific Twitter image from backend (array)
    if (appData.value?.twitter_tags?.[0]?.twitter_image?.url) {
      return `https://content.meander.software${appData.value?.twitter_tags[0].twitter_image.url}`;
    }
    // Third priority: Use general meta image from backend
    if (appData.value?.meta_tags?.meta_image?.url) {
      return `https://content.meander.software${appData.value.meta_tags.meta_image.url}`;
    }
    // Fourth priority: Use app screenshot
    if (appData.value?.screenshot_1?.url) {
      return `https://content.meander.software${appData.value.screenshot_1.url}`;
    }
    return 'https://meander.software/og-default-image.jpg';
  }

  // Set basic meta tags with robust fallbacks - First priority: Backend data
  const title = appData.value?.meta_tags?.meta_title ||
    (appData.value?.name ? `${appData.value.name} - App Development Solution | Meander Software` : 'App Development Solution | Meander Software');
  const description = appData.value?.meta_tags?.meta_description ||
    (appData.value?.description ? `${appData.value.description} Explore ${appData.value.name || 'our app'}, a professional app development solution by Meander Software. Get custom features, pricing plans, and schedule a demo today.` : 'Explore our professional app development solutions by Meander Software. Get custom features, pricing plans, and schedule a demo today.');
  const keywords = appData.value?.meta_tags?.meta_keywords ||
    (appData.value?.keywords || 'app development, software solution, custom app, business software, meander software');
  const imageUrl = getImageUrl();

  // Set page title
  document.title = title;

  // Basic meta tags
  setMeta('title', title);
  setMeta('description', safeTruncate(description, 300));
  setMeta('keywords', safeTruncate(keywords, 300));

  // Open Graph tags - First priority: Backend og_tags, fallback to computed values
  const ogTitle = appData.value?.og_tags?.og_title || title;
  const ogDescription = appData.value?.og_tags?.og_description || safeTruncate(description, 150);
  const ogType = appData.value?.og_tags?.og_type || 'website';
  const ogUrl = window.location.href; // Use current URL since og_url doesn't exist
  const ogImage = appData.value?.og_tags?.og_image?.url ?
    `https://content.meander.software${appData.value.og_tags.og_image.url}` : imageUrl;
  const ogImageWidth = '1200'; // Default since og_image_width doesn't exist
  const ogImageHeight = '630'; // Default since og_image_height doesn't exist
  const ogImageAlt = title; // Use title since og_image_alt doesn't exist

  setMeta('og:title', ogTitle, 'property');
  setMeta('og:description', ogDescription, 'property');
  setMeta('og:type', ogType, 'property');
  setMeta('og:url', ogUrl, 'property');
  setMeta('og:image', ogImage, 'property');
  setMeta('og:image:width', ogImageWidth, 'property');
  setMeta('og:image:height', ogImageHeight, 'property');
  setMeta('og:image:alt', ogImageAlt, 'property');

  // Twitter Card tags - First priority: Backend twitter_tags (array), fallback to computed values
  const twitterTags = appData.value?.twitter_tags?.[0]; // Get first item from array
  const twitterTitle = twitterTags?.twitter_title || title;
  const twitterDescription = twitterTags?.twitter_description || safeTruncate(description, 150);
  const twitterImage = twitterTags?.twitter_image?.url ?
    `https://content.meander.software${twitterTags.twitter_image.url}` : imageUrl;
  const twitterImageAlt = title; // Use title since twitter_image_alt doesn't exist
  const twitterCard = 'summary_large_image'; // Default since twitter_card doesn't exist
  const twitterSite = '@meandersoftware'; // Default since twitter_site doesn't exist
  const twitterCreator = '@meandersoftware'; // Default since twitter_creator doesn't exist

  setMeta('twitter:title', twitterTitle, 'name');
  setMeta('twitter:description', twitterDescription, 'name');
  setMeta('twitter:image', twitterImage, 'name');
  setMeta('twitter:image:alt', twitterImageAlt, 'name');
  setMeta('twitter:card', twitterCard, 'name');
  setMeta('twitter:site', twitterSite, 'name');
  setMeta('twitter:creator', twitterCreator, 'name');

  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', window.location.href);
  } else {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', window.location.href);
    document.head.appendChild(canonical);
  }
};



// Update schema markup when app data changes
watch(appData, (newAppData) => {
  if (newAppData) {
    // Set comprehensive meta tags
    setAppMetaTags();

    // Inject schema markup
    try {
      const schemas = generateAppDetailSchema(newAppData, slug.value);
      injectSchemaMarkup(schemas);
    } catch (error) {
      console.error('Error injecting app detail schema:', error);
    }
  }
}, { immediate: true });

// Reset meta tags on component unmount
onMounted(() => {
  return () => {
    updateMetaTags(defaultMetaData.home);
  };
});

const aboutData = computed(() => {
  if (!appData.value) return null;
  return {
    about_app: appData.value.about_app,
    circle_image: appData.value.circle_image,
  };
});

const faq = computed(() => appData.value?.faq);



const keyFeaturesData = computed(() => {
  if (!appData.value) return null;
  return {
    features: appData.value.key_features?.features,
    title: appData.value.key_features_title,
  };
});
const roleWiseFeaturesData = computed(() => {
  if (!appData.value || !appData.value?.role_wise_features?.feature_names) {
    return null;
  }
  const roleWise = appData.value.role_wise_features;
  return {
    feature_names: roleWise.feature_names,
    title: roleWise.title,
    name: roleWise.name,
  };
});

const whyUsData = computed(() => {
  if (!appData.value) return null;
  return {
    title: appData.value.why_us?.title,
    description: appData.value.why_us?.description,
    image: appData.value.why_us?.image,
  };
});

const scheduleDemoData = computed(() => {
  if (!appData.value) return null;
  return {
    title: appData.value.schedule_demo?.title,
    description: appData.value.schedule_demo?.description,
    image: appData.value.schedule_demo?.image,
  };
});

const appAddOnsData = computed(() => {
  if (!appData.value || !appData.value.app_add_ons) return null;
  return {
    title: appData.value.app_add_ons.title,
    description: appData.value.app_add_ons.description, // if you want to show description
    features: appData.value.app_add_ons.features,
  };
});

const pricingPlanData = computed(() => {
  if (!appData.value || !Array.isArray(appData.value.pricing_plan)) return [];
  console.log('appData.value.pricing_plan',appData.value.pricing_plan);
  
  return appData.value.pricing_plan;
});

const embed_video = computed(() => {
  return appData.value?.embed_video;
});

const videoDescription = computed(() => {
  const name = appData.value?.name || 'App';
  return `Watch our live demo to view the seamless functionality and user-friendly features of our ${name}. Show your customers how easily they can browse through and order their favorite drinks on this platform, track deliveries in real time, and enjoy a smooth and safe shopping experience. You could use the live demo to show the full potential of our ${name} when it comes to disrupting the operations of your startup and putting you on the frontline in the competitive liquor delivery market.`;
});

// Error handling
onError((err) => {
  console.error("Apollo Error:", err);
});



// Markdown rendering for tech_notes and promo_notes
const tech_notes = computed(() => {
  const content = appData.value?.tech_notes || '';
  return md.render(typeof content === 'string' ? content : '');
});

const promo_notes = computed(() => {
  const content = appData.value?.promo_notes || '';
  return md.render(typeof content === 'string' ? content : '');
});

const relatedAppsToShow = computed(() => (appData.value?.related_apps || []).slice(0, 3));
const relatedBlogsToShow = computed(() => (appData.value?.meander_software_blogs || []).slice(0, 3));
</script>